import { SolicitacaoAPI } from '@/api/spgc/solicitacao.api';
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';

const api = new SolicitacaoAPI();

const createSolicitacao = (body: any): AxiosObservable<any> => {
  return api.createSolicitacao(body);
};

const getRegrasValidacao = (): AxiosObservable<any> => {
  return api.getRegrasValidacao();
};

const getSolicitacaoByCnpj = (cnpj: string): AxiosObservable<any> => {
  return api.getSolicitacaoByCnpj(cnpj);
};

const getSolicitacaoByProtocoloAndToken = (
  token: string,
  protocolo: string
): AxiosObservable<any> => {
  return api.getSolicitacaoByProtocoloAndToken(token, protocolo);
};

const signinToUploadDoc = (protocolo: string, token: string): AxiosObservable<any> => {
  return api.signinToUploadDoc(protocolo, token);
};

const updateDocument = (
  conteudoBase64: string,
  idDocument: string,
  protocolo: string
): Promise<any> => {
  return api.updateDocument(conteudoBase64, idDocument, protocolo);
};
const verificarAutorizacaoConsumidorCativo = (cnpj: string): AxiosObservable<any> => {
  return api.verificarAutorizacaoConsumidorCativo(cnpj);
};

const reenviarToken = (protocolo: number, tipoSolicitacao: string): AxiosObservable<any> => {
  return api.reenviarToken(protocolo, tipoSolicitacao);
};

const checkValidAutorizacao = (token: string, protocolo: string): AxiosObservable<any> => {
  return api.checkValidAutorizacao(token, protocolo);
}

export default {
  createSolicitacao,
  getRegrasValidacao,
  getSolicitacaoByCnpj,
  getSolicitacaoByProtocoloAndToken,
  signinToUploadDoc,
  updateDocument,
  verificarAutorizacaoConsumidorCativo,
  reenviarToken,
  checkValidAutorizacao
};
